import { useMemo, useState } from 'react';
import Label from '../../../../ui/label';
import ButtonDropdownOption from '../../../../ui/button-dropdown-option';
import Input from '../../../../ui/input';
import { useDispatch } from 'react-redux';
import { setChannelType, setSubChannelValue } from '../../../../../features/gms-proposal-forms/steps-channel-proposal_as/steps-channel-proposal_as.slice';
import { CHANNEL_TYPE_ID } from '../../../../../constant/gms-constant';
import { customStyle, defaultStyle } from '../../../../../constant/custom-style';
import { useQueries } from '../../../../../hooks/services/queries/use-queries';
import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data';

export default function ChannelType() {

    const dispatch = useDispatch();
    const { 
        channelType, 
        isLoadingChannelType, 
        isFetchingChannelType 
    } = useQueries();
    const {
        channelType: selectedChannelType,
        channelTypeSubName,
        channelTypeNumber,
        channelTypeEmail,
    } = useProposalTypeData()
    const channelNumberValue = channelTypeNumber?.toString() ?? '';
    const [openDropdown, setOpenDropdown] = useState<string | null>(null);
    const defaultChannelType = useMemo(() => ({ id: 0, name: 'Select' }), []);

    const channelTypeOptions = useMemo(() => {
        return [
            defaultChannelType,
            ...(channelType?.map((item) => ({
                id: item.id,
                name: item.name
            })) || [])
        ];
    }, [defaultChannelType, channelType]);

    const channelTypeValue = useMemo(() => {
        return channelTypeOptions.find((option) => option.id === selectedChannelType?.id) || defaultChannelType;
    }, [selectedChannelType, channelTypeOptions, defaultChannelType]);

    const showInput = 
        selectedChannelType?.id === CHANNEL_TYPE_ID.broker
        || selectedChannelType?.id === CHANNEL_TYPE_ID.generalAgency 
        || selectedChannelType?.id === CHANNEL_TYPE_ID.agent;

    return (
        <div className="col-span-1 grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-2">
            <div>
                <Label 
                    label="Channel Type" 
                    requiredText=" *" 
                    isRequired={true} 
                    fontSize="mb-1" 
                />
                <ButtonDropdownOption 
                    width="w-full" 
                    padding="px-3 py-2" 
                    options={channelTypeOptions} 
                    isLoading={isLoadingChannelType || isFetchingChannelType} 
                    value={channelTypeValue} 
                    onChange={(option) => dispatch(setChannelType(option))} 
                    open={openDropdown === 'channel'} 
                    setOpen={() => setOpenDropdown(openDropdown === 'channel' ? null : 'channel')} 
                />
            </div>

            {showInput && (
                <>
                    <div>
                        <Label 
                            label={`${channelTypeValue?.name} Name`} 
                            fontSize="text-xs mb-1" 
                            requiredText=" *" isRequired={true} 
                        />
                        <Input 
                            type="text" 
                            name="channelName" 
                            value={channelTypeSubName || ''} 
                            isCustomStyle={true} 
                            customCss={`${defaultStyle} ${channelTypeSubName ? customStyle : ''}`} 
                            onChange={(e) => dispatch(setSubChannelValue({ type: 'name', value: e.target.value }))} 
                            required={true} placeholder={`Enter name of ${channelTypeValue?.name}`} 
                        />
                    </div>
                    <div>
                        <Label 
                            label={`${channelTypeValue?.name} Number (mobile/landline)`} 
                            fontSize="text-xs mb-1" 
                            requiredText=" *" 
                            isRequired={true} 
                        />
                        <Input 
                            type="tel" 
                            name="channelNumber" 
                            value={channelNumberValue} 
                            isCustomStyle={true} 
                            customCss={`${defaultStyle} ${channelNumberValue ? customStyle : ''}`} 
                            onChange={(e) => { 
                                const value = e.target.value.replace(/\D/g, ""); 
                                dispatch(setSubChannelValue({ type: 'number', value })); 
                            }} 
                            required={true} 
                            placeholder={`Enter number of ${channelTypeValue?.name}`} 
                        />
                    </div>
                    <div>
                        <Label 
                            label={`${channelTypeValue?.name} Email`} 
                            fontSize="text-xs mb-1" 
                            requiredText=" *" 
                            isRequired={true} 
                            />
                        <Input 
                            type="email" 
                            name="channelEmail" 
                            value={channelTypeEmail || ''} 
                            isCustomStyle={true} 
                            customCss={`${defaultStyle} ${channelTypeEmail ? customStyle : ''}`} 
                            onChange={(e) => dispatch(setSubChannelValue({ type: 'email', value: e.target.value }))} 
                            required={true} placeholder={`Enter email of ${channelTypeValue?.name}`} 
                        />
                    </div>
                </>
            )}
        </div>
    );
}